<div class="agenda-container">

  <!-- 📋 Formulaire au-dessus du calendrier -->
  <div class="agenda-form" [class.show]="showForm">
    <h3>Ajouter une tâche</h3>
    <form (ngSubmit)="submitForm()" #form="ngForm">
      <div class="form-grid">
        <div>
          <label>Titre</label>
          <input type="text" [(ngModel)]="formData.title" name="title" required>
        </div>
        <div>
          <label>Date de début</label>
          <input type="date" [(ngModel)]="formData.start" name="start" required>
        </div>
        <div>
          <label>Date de fin</label>
          <input type="date" [(ngModel)]="formData.end" name="end" required>
        </div>

        <!-- Nouveau : Type de tâche -->
        <div>
          <label>Type de tâche</label>
          <select [(ngModel)]="formData.taskTypeId" name="taskTypeId" required (change)="onTaskTypeChange()">
            <option *ngFor="let type of taskTypes" [value]="type.id">{{ type.label }}</option>
          </select>
        </div>

        <!-- Nouveau : Liste d’échantillons conditionnelle -->
        <div *ngIf="showSampleSelect">
          <label>Échantillon associé</label>
          <select [(ngModel)]="formData.sampleId" name="sampleId" required>
            <option *ngFor="let sample of samples" [value]="sample.id">{{ sample.sampleCode }}</option>
          </select>
        </div>
      </div>

      <div class="form-buttons">
        <button type="submit" [disabled]="!form.valid">Ajouter</button>
        <button type="button" (click)="resetForm()">Annuler</button>
      </div>
    </form>
  </div>

  <!-- 🗓️ Calendrier -->
  <full-calendar [options]="calendarOptions"></full-calendar>
  <ng-template #taskDetailModal>
    <mat-card class="p-4">
      <h3 class="mb-3">Détails de la tâche</h3>
  
      <p><strong>Titre :</strong> {{ selectedTask?.name }}</p>
      <p><strong>Date début :</strong> {{ selectedTask?.startDate | date: 'shortDate' }}</p>
      <p><strong>Date fin :</strong> {{ selectedTask?.endDate | date: 'shortDate' }}</p>
      <p><strong>Créé par :</strong> {{ selectedTask?.createdBy || 'N/A' }}</p>
  
      <!-- ✅ Type de tâche via selectedTask.taskTypeLabel -->
      <p><strong>Type de tâche :</strong> {{ selectedTask?.taskTypeLabel || 'N/A' }}</p>

      <!-- ✅ Échantillon via selectedTask.sampleName -->
      <p *ngIf="selectedTask?.sampleName">
        <strong>Échantillon :</strong> {{ selectedTask?.sampleName }}
      </p>

  
      <button 
        type="button" 
        matTooltip="Supprimer" 
        matTooltipPosition="above"
        (click)="confirmDeleteTask(selectedTask!.id)"
        class="delete-btn"
      >
        <i class="material-symbols-outlined">delete</i>
      </button>

    </mat-card>
  </ng-template>
  
</div>
